import { APIService } from '@app/_services/api.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { MAIN_DOMAIN, API_PATH } from '@app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class AnalyticService {
    constructor(private http: HttpClient, private api: APIService) {}

    public getAverageSpeedGraph(lesson_id: string, count: number): Observable<any> {
        return this.http.get<any>(
            `${MAIN_DOMAIN}/api/main_analytics/average-resolve-speed-graph/${lesson_id}/?count=${count}`
        );
    }

    public getAverageCurrenciesGraph(lesson_id: string, count: number): Observable<any> {
        return this.http.get<any>(
            `${MAIN_DOMAIN}/api/main_analytics/average-currencies-amount-speed-graph/${lesson_id}/?count=${count}`
        );
    }

    public getAverageErrorGraph(lesson_id: string, count: number): Observable<any> {
        return this.http.get<any>(
            `${MAIN_DOMAIN}/api/main_analytics/average-error-percent-graph/${lesson_id}/?count=${count}`
        );
    }

    public getStudentSolvedGraph(lesson_id: string, count: number, themeParam: string): Observable<any> {
        return this.http.get<any>(
            `${MAIN_DOMAIN}/api/main_analytics/stable-student-solved-graph/${lesson_id}/?count=${count}&${themeParam}`
        );
    }

    public getStudentBoxesAnalytics(student: any, box: any): Observable<any> {
        return this.http.get<any>(`${MAIN_DOMAIN}/api/main_analytics/student-exercises-box/${student}/${box}/`);
    }

    public createReportsCSVdata(requestData): Observable<any> {
        return this.api.post(API_PATH.main_analytics.create_reports_csv_data, requestData);
    }
}
